import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faArrowRight, faNewspaper, faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import '../styles/Postingan.css';

// Helper function untuk mendapatkan API URL
const getApiUrl = () => {
  // Development mode (React dev server on port 3000)
  if (window.location.port === '3000') {
    return 'http://localhost/stikbar_webv2/public';
  }
  // Production mode
  if (window.location.hostname === 'stikesbaramuli.ac.id' || window.location.hostname === 'www.stikesbaramuli.ac.id') {
    return 'https://stikesbaramuli.ac.id';
  }
  return '';
};

// Helper function untuk mendapatkan URL gambar
const getImageUrl = (gambar) => {
  if (!gambar) return '/images/logo.png';
  if (gambar.startsWith('http')) return gambar;
  return `${getApiUrl()}${gambar}`;
};

// Helper function untuk format tanggal
const formatTanggal = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('id-ID', options);
};

const Postingan = () => {
  const [postingan, setPostingan] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKategori, setActiveKategori] = useState("Semua");
  const [searchQuery, setSearchQuery] = useState("");

  const kategoriList = ["Semua", "pengumuman", "berita", "akademik", "kegiatan", "prestasi"];

  useEffect(() => {
    fetchPostingan();
  }, []);

  const fetchPostingan = async () => {
    try {
      setLoading(true);
      const baseUrl = getApiUrl();
      const response = await fetch(`${baseUrl}/api/postingan.php?limit=50`);
      const result = await response.json();
      
      if (result.success) {
        setPostingan(result.data.filter(post => post.is_active === 1 || post.is_active === '1'));
      }
    } catch (err) {
      console.error('Error fetching postingan:', err);
    } finally {
      setLoading(false);
    }
  };

  const filteredPosts = postingan.filter(post => {
    const matchKategori = activeKategori === "Semua" || post.kategori === activeKategori;
    const matchSearch = post.judul.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        (post.ringkasan && post.ringkasan.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchKategori && matchSearch;
  });

  return (
    <main className="postingan-page">
      {/* Hero Section */}
      <section className="postingan-hero">
        <div className="postingan-hero-overlay"></div>
        <div className="container">
          <h1>Berita & Informasi</h1>
          <p>Ikuti berita dan informasi terkini seputar STIKES Baramuli</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="postingan-content-section section">
        <div className="container">
          {/* Filter & Search */}
          <div className="postingan-filter">
            <div className="filter-kategori">
              {kategoriList.map((kategori) => (
                <button
                  key={kategori}
                  className={`filter-btn ${activeKategori === kategori ? 'active' : ''}`}
                  onClick={() => setActiveKategori(kategori)}
                >
                  {kategori === "Semua" ? "Semua" : kategori.charAt(0).toUpperCase() + kategori.slice(1)}
                </button>
              ))}
            </div>
            <div className="filter-search">
              <FontAwesomeIcon icon={faSearch} />
              <input
                type="text"
                placeholder="Cari postingan..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Loading State */}
          {loading ? (
            <div className="loading-state">
              <FontAwesomeIcon icon={faSpinner} spin size="3x" />
              <p>Memuat postingan...</p>
            </div>
          ) : (
            /* Posts Grid */
            <div className="postingan-grid">
              {filteredPosts.length > 0 ? (
                filteredPosts.map((post) => (
                  <div key={post.id} className="post-card">
                    <div className="post-image">
                      <img 
                        src={getImageUrl(post.gambar)} 
                        alt={post.judul}
                        onError={(e) => {
                          e.target.src = '/images/logo.png';
                        }}
                      />
                      <span className="post-kategori">
                        {post.kategori ? post.kategori.charAt(0).toUpperCase() + post.kategori.slice(1) : 'Umum'}
                      </span>
                    </div>
                    <div className="post-body">
                      <div className="post-meta">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        <span>{formatTanggal(post.created_at || post.tanggal_mulai)}</span>
                      </div>
                      <h3>{post.judul}</h3>
                      <p>{post.ringkasan || (post.konten && post.konten.substring(0, 150) + '...')}</p>
                      {post.link_url ? (
                        <a href={post.link_url} target="_blank" rel="noopener noreferrer" className="post-link">
                          Baca Selengkapnya <FontAwesomeIcon icon={faArrowRight} />
                        </a>
                      ) : (
                        <Link to={`/postingan/${post.id}`} className="post-link">
                          Baca Selengkapnya <FontAwesomeIcon icon={faArrowRight} />
                        </Link>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-posts">
                  <FontAwesomeIcon icon={faNewspaper} />
                  <h3>Tidak ada postingan ditemukan</h3>
                  <p>Coba ubah filter atau kata kunci pencarian</p>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Postingan;
